import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/utils/auth";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import("@/views/Maintenance.vue"),
      meta: {
        title: "Maintenance",
        data: [
          {
            description:
              "NiuNiuBox is temporarily unavailable for scheduled maintenance.",
          },
        ],
      },
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        title: import.meta.env.VITE_APP_SITE_NAME,
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services,taobao english",
          },
          {
            description:
              "Your Trusted China Buying Agent. Buy and ship from Taobao, Weidian, 1688 and Yupoo. Product Sourcing Services to Import from China by cheap agent. ",
          },
        ],
      },
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: () => import("@/views/Pricing.vue"),
      meta: {
        title:
          "1688 Product Sourcing Agent | Taobao Buying | Dropshipping Price",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "We help you buy and ship from China Market. Lower shipping price and faster international shipping service. Ship your products from China now.",
          },
        ],
      },
    },
    {
      path: "/product",
      name: "Taobao Products",
      component: () => import("@/views/Product.vue"),
      meta: {
        title: "Taobao Shopping | Weidian English | 1688 Product Sourcing",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Start buying products from the Chinese market. Shop on Taobao in English, Product sourcing service, Global order fulfillment, ",
          },
        ],
      },
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: () => import("@/views/AboutUs.vue"),
      meta: {
        title: "China Sourcing Agent | Weidian Buy | Taobao Shopping",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Help global users buy and ship from China. Shop from Taobao, Yupoo, 1688, Weidian in English. We provide cheap logistics solutions by UPS, DHL, FedEx.",
          },
        ],
      },
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: () => import("@/views/ContactUs.vue"),
      meta: {
        title:
          "Taobao Agent | Product Sourcing Agent | China Freight Forwarder",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Contact us and submit purchasing orders and shipping orders. Sourcing products from 1688.com and shop from Taobao.com. Start to order from China market.",
          },
        ],
      },
    },
    {
      path: "/submit-inquiry",
      name: "SubmitInquiry",
      component: () => import("@/views/SubmitInquiry.vue"),
      meta: {
        title: "Taobao Buying in English | Weidian Agent | Yupoo Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Sourcing and Shipping from China. Get a Free Quote. Customize order for better service and lower prices. China logistics company help you ship.",
          },
        ],
      },
    },
    {
      path: "/submit-order-success",
      name: "submit-order-success",
      component: () => import("@/views/SubmitOrderSuccess.vue"),
      meta: {
        title: "Submit Order Success",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          { description: "Place order success." },
        ],
      },
    },
    {
      path: "/dropshipping",
      name: "Dropshipping",
      component: () => import("@/views/Dropshipping.vue"),
      meta: {
        title:
          "Dropshipping Fulfillment | 1688 Dropshipping | Taobao Dropshipping",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Dropshipping From 1688, Taobao, Weidian and Aliexpress. Dropshipping fulfillment is a popular method provides one-stop solution for e-commerce sellers. ",
          },
        ],
      },
    },
    {
      path: "/taobao-agent",
      name: "TaobaoAgent",
      component: () => import("@/views/TaobaoAgent.vue"),
      meta: {
        title: "Taobao Agent | Taobao English | Buy From Taobao ",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Taobao Shopping Agent: Help global users buy from Taobao. We provide cheaper and faster international logistic service. One-stop shopping and shipping solution.",
          },
        ],
      },
    },
    // {
    //     path: "/forwarding",
    //     name: "Forwarding",
    //     component: () => import('@/views/Forwarding.vue'),
    //     meta: {
    //         title: "China Forwarding Agent | Taobao Forwarder | Ship From China",
    //         data: [
    //             {keywords: "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services"},
    //             {description: "Trusted China Freight Forwarder Helps You Ship Packages From China. Air/Sea/Express Freight. Worldwide shipping from China by cheap shipping agent."}
    //         ]
    //     }
    // },
    {
      path: "/sourcing-china-products",
      name: "ProductSourcingService",
      component: () => import("@/views/ProductSourcing.vue"),
      meta: {
        title: "1688 Product Sourcing | Weidian Shop | Import From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "China Product Sourcing Agent. Help you source best price products from 1688, Aliexpress and manufacturers. 0% service fee for wholesale service.",
          },
        ],
      },
    },
    {
      path: "/weidian-agent-english-buy",
      name: "WeidianAgentEnglishBuy",
      component: () => import("@/views/WeidianAgentBuy.vue"),
      meta: {
        title:
          "Weidian English Buying Agent | Weidian Shoes | Weidian Sneakers",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "The popular Weidian Agent in China helps you buy fashion sneakers,clothes and bags from Weidian. Save more to buy cheap and high quality products from Weidian.",
          },
        ],
      },
    },
    {
      path: "/yupoo-agent-buy",
      name: "YupooAgentBuy",
      component: () => import("@/views/YupooAgent.vue"),
      meta: {
        title: "Best Yupoo Agent | Yupoo Shoes | Yupoo Sneakers",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "The best Yupoo shopping agent in China helping you buy the fashion shoes and clothes. How to order from Yupoo by a cheap agent and save more money?",
          },
        ],
      },
    },
    {
      path: "/shipping-policy",
      name: "ShippingPolicy",
      component: () => import("@/views/ShippingPolicy.vue"),
      meta: {
        title: "Shipping Policy - Buy From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Best International Freight Forwarder Based in China. Ship your parcels from China. Air/Sea/Express Freight - Customs Clearance - Warehouse. Best Rates.",
          },
        ],
      },
    },
    {
      path: "/shopping/payment-processing",
      name: "PaymentProcessing",
      component: () => import("@/views/OrderCart/PaymentProcessing.vue"),
      meta: {
        title: "Processing Payment",
        requireAuth: true,
        data: [
          {
            keywords: "payment processing,credit card payment,order payment",
          },
          {
            description: "Processing your payment",
          },
        ],
      },
    },
    {
      path: "/refund-and- urn",
      name: "RefundAndReturn",
      component: () => import("@/views/RefundAndReturn.vue"),
      meta: {
        title: "Refund And Return - Shop Taobao",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Help you shop/source/wholesale from China market. Easy to refund and return.",
          },
        ],
      },
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: () => import("@/views/PrivacyPolicy.vue"),
      meta: {
        title: "Privacy Policy - Weidian English Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description: "Global logistics service from China to your country.",
          },
        ],
      },
    },
    {
      path: "/terms-of-service",
      name: "TermsOfService",
      component: () => import("@/views/TermsService.vue"),
      meta: {
        title: "Terms of Service - China Shopping Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description: "Global logistics service from China to your country.",
          },
        ],
      },
    },
    {
      path: "/payment-method",
      name: "PaymentMethod",
      component: () => import("@/views/PaymentMethod.vue"),
      meta: {
        title: "Payment Methods | Taobao Shopping | Weidian Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Payment Methods Accepted By our site. Make your payment and shop from China. Safe payment to buy from Taobao.",
          },
        ],
      },
    },
    {
      path: "/blog-list",
      name: "BlogList",
      component: () => import("@/views/BlogList.vue"),
      meta: {
        title: "Blogs | Taobao Agent | China Sourcing Agent | 1688 Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, packing, and shipping services to global customers. We help you to buy and ship from China. ",
          },
        ],
      },
    },
    {
      path: "/blog-detail/:path",
      name: "BlogDetail",
      component: () => import("@/views/BlogDetail.vue"),
      meta: {
        title: "",
        data: [{ keywords: "" }, { description: "" }],
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login.vue"),
      meta: {
        title: "Sign in | Taobao Shopping | Weidian Shoes",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, shipping, packing services to global customers. We help you buy and ship from Taobao, Weidian. ",
          },
        ],
      },
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: () => import("@/views/SignUp.vue"),
      meta: {
        title: "Sign in | Taobao Shopping | Weidian Shoes",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, shipping, packing services to global customers. We help you buy and ship from Taobao, Weidian. ",
          },
        ],
      },
    },
    {
      path: "/verify_account",
      name: "verify_account",
      component: () => import("@/views/VerifyAccountPage.vue"),
      meta: {
        title: "Verify Account",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, shipping, packing services to global customers. We help customers buy and ship from Taobao and 1688. ",
          },
        ],
      },
    },
    {
      path: "/register-success",
      name: "register-success",
      component: () => import("@/views/RegisterSuccess.vue"),
      meta: {
        title: "Register Success",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, shipping, packing services to global customers. We help customers buy and ship from Taobao and 1688. ",
          },
        ],
      },
    },
    {
      path: "/mobile-menu",
      name: "/mobile-menu",
      component: () => import("@/views/Backend/MobileMenu.vue"),
      meta: {
        title: "Our Services | China Shopping Agent | Taobao Forwarding Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Product Sourcing From China. We provide sourcing, warehousing, shipping, packing services to global customers. We help customers buy and ship from Taobao and 1688. ",
          },
        ],
      },
    },
    {
      path: "/shipping-calculator",
      name: "/shipping-calculator",
      component: () => import("@/views/ShippingCalculator.vue"),
      meta: {
        title: "China Shipping Cost Calculator | Buy and Ship From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "China Taobao shopping agent. Order your favorite products from home. Purchase products from Taobao in English. No service fee, import from China.",
          },
        ],
      },
    },
    {
      path: "/shipping-calculator-test",
      name: "/shipping-calculator-test",
      component: () => import("@/views/ShippingCalculatorTest.vue"),
      meta: {
        title: "China Shipping Cost Calculator | Buy and Ship From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "China Taobao shopping agent. Order your favorite products from home. Purchase products from Taobao in English. No service fee, import from China.",
          },
        ],
      },
    },
    {
      path: "/affiliation-test",
      name: "/affiliation-test",
      component: () => import("@/views/Backend/UserCenter/AffiliationTest.vue"),
      meta: {
        title: "China Shipping Cost Calculator | Buy and Ship From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "China Taobao shopping agent. Order your favorite products from home. Purchase products from Taobao in English. No service fee, import from China.",
          },
        ],
      },
    },
    {
      path: "/find-and-buy",
      name: "/find-and-buy",
      component: () => import("@/views/ProductSourcing.vue"),
      meta: {
        title: "China Shipping Cost Calculator | Buy and Ship From China",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "China Taobao shopping agent. Order your favorite products from home. Purchase products from Taobao in English. No service fee, import from China.",
          },
        ],
      },
    },
    {
      path: "/taobao-shopping-guide",
      name: "Taobao Shopping Guide | How To Buy From China",
      component: () => import("@/views/NewGuide/ShoppingGuide.vue"),
      meta: {
        title: "Taobao Shopping Guide | Buy From Taobao, Weidian, 1688",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "How to buy from Taobao, 1688, Tmall, Weidain, Aliexpress? Complete Guide 2023. Shop From Taobao in English. Popular Taobao shopping agent in China.",
          },
        ],
      },
    },
    {
      path: "/test/taobao-shopping-guide-test",
      name: "123",
      component: () => import("@/views/NewGuide/ShoppingGuideTest.vue"),
      meta: {
        title: "123",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "How to buy from Taobao, 1688, Tmall, Weidain, Aliexpress? Complete Guide 2023. Shop From Taobao in English. Popular Taobao shopping agent in China.",
          },
        ],
      },
    },
    // {
    //     path: "/ship-from-china-guide",
    //     name: "Guide To Forwarding Packages From China - Ship From China",
    //     component: () => import('@/views/NewGuide/ForwardingGuide.vue'),
    //     meta: {
    //         title: "Ship From China | Guide To Ship Parcels From China",
    //         data: [
    //             {keywords: "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services"},
    //             {description: "Complete Guide To Ship Parcels From China. Trusted China freight forwarder helps you ship packages from China to your country by cheap shipping services."}
    //         ]
    //     }
    // },
    // {
    //     path: "/expert-buy",
    //     name: "Expert Buy",
    //     component: () => import('@/views/ExpertBuy.vue'),
    //     meta: {
    //         title: "Taobao Expert Buy | Taobao Wholesale | Weidian Agent",
    //         data: [
    //             {keywords: "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services"},
    //             {description: "Expert buy helps you shop any products from China. Shop from Taobao, Weidian, 1688, Yupoo, Wechat sellers. Make a shopping plan for you."}
    //         ]
    //     }
    // },
    {
      path: "/customer-review",
      name: "Customer Review",
      component: () => import("@/views/CustomerReview.vue"),
      meta: {
        title: "China Expert Buy | Taobao Order | Weidian Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Expert buy helps you shop any products from China. Shop from Taobao, Weidian, 1688, Yupoo, Wechat sellers. Make a shopping plan for you.",
          },
        ],
      },
    },
    {
      path: "/admin-user-login",
      name: "Admin User Login",
      component: () => import("@/views/AdminUserLogin.vue"),
      meta: {
        title: "Admin User Login",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Expert buy helps you shop any products from China. Shop from Taobao, Weidian, 1688, Yupoo, Wechat sellers. Make a shopping plan for you.",
          },
        ],
      },
    },
    {
      path: "/warehouse-address",
      name: "WarehouseAddress",
      component: () => import("@/views/WarehouseAddress.vue"),
      meta: {
        title: "Warehouse Address | China Shipping Agent",
        data: [
          {
            keywords:
              "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
          },
          {
            description:
              "Trusted China shipping agent helps you ship products from China. Buy from Taobao, Weidian and 1688. We provide global shipping services.",
          },
        ],
      },
    },
    {
      path: "/image-search-result",
      name: "Image Search Result",
      component: () => import("@/views/ImageSearchResult.vue"),
      meta: {
        title: "Image Search Result | China Shipping Agent",
        data: [
          {
            keywords:
              "China shipping agent, warehouse address, product search, Taobao, 1688, JD, image search result, import, logistics",
          },
          {
            description:
              "Find products with image search from Taobao, 1688, and JD, supported by a trusted China shipping agent for seamless logistics and warehouse services.",
          },
        ],
      },
    },

    //需要开始登陆的页面
    {
      path: "/product-detail",
      name: "product-detail",
      component: () => import("@/views/ProductDetailRoute.vue"),
      meta: {
        title: "Product",
        data: [
          { keywords: "" }, //需要登录的不用加meta其他信息
          { description: "" },
        ],
        needLogin: false, //不需要登录
      },
    },
    {
      path: "/product-detail-self",
      name: "product-detail-self",
      component: () => import("@/views/Product/ProductDetail.vue"),
      meta: {
        title: "Product",
        data: [
          { keywords: "" }, //需要登录的不用加meta其他信息
          { description: "" },
        ],
        needLogin: false, //不需要登录
      },
    },
    {
      path: "/cart",
      name: "cart",
      component: () => import("@/views/OrderCart/UserCart.vue"),
      meta: {
        title: "My Cart",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/settlement",
      name: "shopping/settlement",
      component: () => import("@/views/OrderCart/ShoppingSettlement.vue"),
      meta: {
        title: "Settlement",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/payment",
      name: "shopping/payment",
      component: () => import("@/views/OrderCart/ShoppingPayment.vue"),
      meta: {
        title: "Payment",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/pay_success",
      name: "/shopping/pay_success",
      component: () => import("@/views/OrderCart/PaySuccess.vue"),
      meta: {
        title: "Pay Success",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/pay_failed",
      name: "/shopping/pay_failed",
      component: () => import("@/views/OrderCart/PayFailed.vue"),
      meta: {
        title: "Pay Failed",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/delivery/payment",
      name: "/delivery/payment",
      component: () => import("@/views/OrderCart/ShippingPayment.vue"),
      meta: {
        title: "Shipping Payment",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/offline-payment",
      name: "/shopping/offline-payment",
      component: () => import("@/views/OrderCart/OfflinePayment.vue"),
      meta: {
        title: "Payment Methods",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },
    {
      path: "/shopping/offline-submit-payment-success",
      name: "/shopping/offline-submit-payment-success",
      component: () =>
        import("@/views/OrderCart/OfflineSubmitPaymentSuccess.vue"),
      meta: {
        title: "Offline Payment Submit Success",
        data: [{ keywords: "" }, { description: "" }],
        needLogin: true, //需要登录
      },
    },

    //这里是全部用户中心的页面-都需要登录

    {
      path: "/user",
      component: () => import("@/views/Backend/SidebarLayout.vue"),
      meta: { needLogin: true },
      children: [
        {
          path: "my-orders",
          name: "My Orders",
          component: () => import("@/views/Backend/MyOrders/Orders.vue"),
          meta: { needLogin: true },
        },
        {
          path: "forwarding-orders",
          name: "Forwarding Orders",
          component: () => import("@/views/Backend/MyOrders/ForwardingOrders.vue"),
          meta: { needLogin: true },
        },
        {
          path: "order-history",
          name: "Order History",
          component: () => import("@/views/Backend/MyOrders/OrderHistory.vue"),
          meta: { needLogin: true },
        },
        {
          path: "order-detail",
          name: "Order Detail",
          component: () => import("@/views/Backend/MyOrders/OrderDetail.vue"),
          meta: { needLogin: true },
        },
        {
          path: "delivery-detail",
          name: "Shipping Detail",
          component: () => import("@/views/Backend/MyOrders/DeliveryDetail.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-warehouse",
          name: "In Warehouse",
          component: () => import("@/views/Backend/MyOrders/InWarehouse.vue"),
          meta: { needLogin: true },
        },
        {
          path: "parcel-rehearsal",
          name: "ParcelRehearsal",
          component: () => import("@/views/Backend/MyOrders/ParcelRehearsal.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-rehearsal",
          name: "My Rehearsal",
          component: () => import("@/views/Backend/MyOrders/MyRehearsal.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-parcels",
          name: "My Parcels",
          component: () => import("@/views/Backend/MyOrders/MyParcels.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-cancel",
          name: "Cancel",
          component: () => import("@/views/Backend/MyOrders/CancelOrder.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-profile",
          name: "User Center",
          component: () => import("@/views/Backend/UserCenter/MyProfile.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-address",
          name: "Address Book",
          component: () => import("@/views/Backend/UserCenter/MyAddress.vue"),
          meta: { needLogin: true },
        },
        {
          path: "coupon-list",
          name: "User coupon list",
          component: () => import("@/views/Backend/UserCenter/CouponList.vue"),
          meta: { needLogin: true },
        },
        {
          path: "coupon-list-test",
          name: "User coupon list Test",
          component: () => import("@/views/Backend/UserCenter/CouponListTest.vue"),
          meta: { needLogin: true },
        },
        {
          path: "my-balance",
          name: "My Balance",
          component: () => import("@/views/Backend/UserCenter/UserBalance.vue"),
          meta: { needLogin: true },
        },
        {
          path: "balance-payment",
          name: "Balance payment",
          component: () => import("@/views/Backend/UserCenter/BalancePayment.vue"),
          meta: { needLogin: true },
        },
        {
          path: "message-center",
          name: "Message Center",
          component: () => import("@/views/Backend/UserCenter/Message.vue"),
          meta: { needLogin: true },
        },
        {
          path: "affiliation",
          name: "Affiliation",
          component: () => import("@/views/Backend/UserCenter/Affiliation.vue"),
          meta: {
            needLogin: true,
            title: "China Shipping Cost Calculator | Buy and Ship From China",
            data: [
              {
                keywords:
                  "dropshipping fulfillment,taobao agent,ecommerce fulfillment,taobao forwarder,china freight forwarder,global logistics,ship from china,buy chinese products,fulfillment services",
              },
              {
                description:
                  "China Taobao shopping agent. Order your favorite products from home. Purchase products from Taobao in English. No service fee, import from China.",
              },
            ],
          },
        },
        {
          path: "tracking-info",
          name: "Tracking Info",
          component: () => import("@/views/Backend/MyOrders/TrackingInfo.vue"),
          meta: { needLogin: true },
        },
        {
          path: "shipping-address-info",
          name: "Shipping Address Info",
          component: () => import("@/views/Backend/MyOrders/ShippingAddressInfo.vue"),
          meta: { needLogin: true },
        },
        {
          path: "account-setting",
          name: "Account Setting",
          component: () => import("@/views/Backend/UserCenter/AccountSetting.vue"),
          meta: { needLogin: true },
        },
      ],
    },


    {
      path: "/404", // 此处需特别注意置于最底部
      name: "404",
      component: () => import("@/views/404.vue"),
    },

    {
      path: "/site-migration",
      name: "SiteMigration",
      component: () => import("@/views/RedirectPage.vue"),
      props: () => {
        const explicit = (
          import.meta.env.VITE_MIGRATION_NEW_SITE_URL || ""
        ).trim();
        const domain = import.meta.env.VITE_APP_DOMAIN || "";
        return {
          target: explicit || domain,
          headline: "We’ve moved!",
          lead:
            "We have moved to a new home! Redirects are handled automatically, or open the new site using the link below.",
        };
      },
      meta: {
        title: "redirect to new website",
        data: [
          {
            description:
              "This site has moved. Use the link on this page to open the new website.",
          },
        ],
      },
    },

    {
      path: "/autorouter", // 此处需特别注意置于最底部
      name: "autorouter",
      component: () => import("@/router/AutoRouter.vue"),
    },
    //这个一定要放末尾 路由不存在眺首页
    {
      path: "/:pathMath(.*)", // 此处需特别注意置于最底部
      redirect: "/404",
    },
  ],
});

//router/index.js
const writer = (to) => {
  if (to.name == "BlogDetail") {
    //博客页是主要seo页面 单独页面做设置即可
    return;
  }

  //设置规范页面 防止有奇怪的异常提醒

  //首先找到head里的meta
  const deleArr = [];
  document.head.childNodes.forEach((item) => {
    switch (item.tagName) {
      case "META":
        deleArr.push(item);
        break;
      case "TITLE":
        //顺便设置title
        document.title = to.meta.title || to.name;
        break;
    }
  });

  //删除原来的meta
  deleArr.forEach((item) => {
    document.head.removeChild(item);
  });

  //添加想要的meta（全局）
  const metas = document.createElement("META");
  const creatArr = [
    { charset: "utf-8" },
    { "http-equiv": "X-UA-Compatible", content: "IE=edge" },
    //视图缩放
    {
      name: "viewport",
      content:
        "width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no,minimal-ui",
    },
  ];

  //将单个路由设定的meta加到creatArr数组中
  //局部meta和全局meta重复时，局部meta替换全局meta
  let tmpArr = to.meta.data ? to.meta.data.concat() : [];
  let new_meta = [];
  for (let i in tmpArr) {
    if (tmpArr[i].keywords) {
      new_meta.push({ name: "keywords", content: tmpArr[i].keywords });
    }
    if (tmpArr[i].description) {
      new_meta.push({ name: "description", content: tmpArr[i].description });
    }
  }
  tmpArr = new_meta;

  if (tmpArr.length > 0) {
    to.meta.data.forEach((item, index) => {
      creatArr.forEach((ele, ind) => {
        if (Object.keys(item)[0] == Object.keys(ele)[0]) {
          creatArr[ind] = JSON.parse(JSON.stringify(item));
          tmpArr.splice(index, 1);
        }
      });
    });
  }

  //生成合并后的数组
  const eleArr = creatArr.concat(tmpArr);

  //将设定的值写入文档片段
  const creatFrag = document.createDocumentFragment();
  eleArr.forEach((ele) => {
    creatFrag.append(metas.cloneNode());
    Object.entries(ele).forEach((item) => {
      creatFrag.lastChild.setAttribute(item[0], item[1]);
    });
  });

  //将文档片段写入head
  document.head.prepend(creatFrag);
};

const MAINTENANCE_ALLOWED_NAMES = new Set([
  "maintenance",
  "home",
  "product-detail",
]);

router.beforeEach((to, from, next) => {
  if (import.meta.env.VITE_MAINTENANCE_MODE === "true") {
    if (!MAINTENANCE_ALLOWED_NAMES.has(to.name)) {
      next({ path: "/maintenance", replace: true });
      return;
    }
  }

  window.scrollTo(0, 0); //滚动到页面顶部
  let token = getToken();
  if (to.meta && to.meta.needLogin) {
    // 判断该路由是否需要登录权限
    if (!token) {
      // 判断是否已经登录
      next({ path: "/login" }); //跳转到登录页
    }
  }

  writer(to); //调用自动添加meta

  next();
});

export default router;
